import { render, staticRenderFns } from "./ThesisManagement.vue?vue&type=template&id=0880094a&scoped=true&"
import script from "./ThesisManagement.vue?vue&type=script&lang=js&"
export * from "./ThesisManagement.vue?vue&type=script&lang=js&"
import style0 from "./ThesisManagement.vue?vue&type=style&index=0&id=0880094a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880094a",
  null
  
)

export default component.exports